import dayjs from "dayjs";

import { DateInput, DatePickerInput, DateTimePicker } from '@mantine/dates';
import { Button, Group, Loader, Modal, NumberInput, TextInput, Textarea } from "@mantine/core";
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import 'dayjs/locale/zh-tw';
import { prop, values } from "remeda";
import { ChatCreditKey, getApiAdminChatCreditKeyGet, getGetApiAdminChatCreditKeyListByUserIdQueryKey, usePutApiAdminChatCreditKeyUpdate } from "@/API";
import { ConvertToTimestampInputProps } from "@/Helpers/FormHelper";

export function UpdateCreditKeyDialog(props: { id: string, opened: boolean, onClose: () => void }) {
    const queryClient = useQueryClient()
    const EditKey_Mutation = usePutApiAdminChatCreditKeyUpdate()
    const [isloaded, setIsloaded] = useState(false)
    const form = useForm<ChatCreditKey>({
        initialValues: {

        },
        validate: {
            credit: (value, values) => (value ?? 0) > (values.totalCredit ?? 0) ? "聊天點數不得大於聊天點數總數" : null
        }
    });
    useEffect(() => {
        if (props.opened) {
            setIsloaded(false)
            form.reset()
            getApiAdminChatCreditKeyGet({ id: props.id }).then(x => {
                form.setValues(x.data)
                setIsloaded(true)
            })
        }
    }, [props.opened])
    return <>
        <Modal opened={props.opened} onClose={props.onClose} title="修改儲值金鑰">
            {isloaded ?
                <form onSubmit={form.onSubmit(async (values) => {
                    try {
                        await EditKey_Mutation.mutateAsync({
                            data: values
                        })
                        queryClient.invalidateQueries({ queryKey: getGetApiAdminChatCreditKeyListByUserIdQueryKey() })
                        notifications.show({ message: "修改成功" })
                        props.onClose()
                    } catch (e) {
                        notifications.show({ message: "修改失敗", color: "red" })
                    }
                })}>
                    <DateTimePicker
                        label="開始時間"
                        locale="zh-tw"
                        valueFormat="YYYY/MM/DD HH:mm"
                        {...ConvertToTimestampInputProps(form.getInputProps('startTimestamp'))}
                    />
                    <DateTimePicker
                        label="到期時間"
                        locale="zh-tw"
                        valueFormat="YYYY/MM/DD HH:mm"
                        {...ConvertToTimestampInputProps(form.getInputProps('endTimestamp'))}
                    />
                    <NumberInput
                        label="聊天點數"
                        min={0}
                        {...form.getInputProps('credit')}
                    />
                    <NumberInput
                        label="聊天點數總數"
                        min={0}
                        description="只用來給使用看當初總共獲得多少點數"
                        {...form.getInputProps('totalCredit')}
                    />
                    <Textarea
                        label="註記"
                        rows={5}
                        {...form.getInputProps('description')}
                    />
                    <Group justify="flex-end" mt="md">
                        <Button type="submit">修改</Button>
                    </Group>
                </form>
                : <Loader />}
        </Modal>
    </>
}